import { RefObject, useState } from "react";
import html2canvas from 'html2canvas-pro';
import jsPDF from 'jspdf';

export const usePdfGenerator = (contentRef: RefObject<HTMLDivElement>) => {
  const [isGenerating, setIsGenerating] = useState(false); // loading state

  const A4_WIDTH_PX = 595.28;
  const A4_HEIGHT_PX = 841.89;
  const MARGIN_TOP_BOTTOM = 40;
  const MARGIN_LEFT_RIGHT = 20;

  const generatePdf = async () => {
    const element = contentRef.current;
    if (!element) {
      console.error("PDF generation failed: Content element not found.");
      return;
    }

    setIsGenerating(true); // start loading
    try {
      const canvas = await html2canvas(element, {
        scale: 2, // reduce scale to speed up and reduce size
        backgroundColor: "#ffffff",
      });

      const contentWidth = A4_WIDTH_PX - MARGIN_LEFT_RIGHT * 2;
      const contentHeight = (canvas.height * contentWidth) / canvas.width;

      const pdf = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: "a4",
        compress: true,
      });

      const pageHeight = A4_HEIGHT_PX - MARGIN_TOP_BOTTOM * 2;

      let position = 0;

      while (position < contentHeight) {
        const remainingHeight = contentHeight - position;
        const currentPageHeight = Math.min(pageHeight, remainingHeight);
      
        const pageCanvas = document.createElement("canvas");
        const ctx = pageCanvas.getContext("2d")!;
      
        const sX = 0;
        const sY = (position * canvas.height) / contentHeight;
        const sHeight = (currentPageHeight * canvas.height) / contentHeight;
      
        pageCanvas.width = canvas.width;
        pageCanvas.height = sHeight;
      
        ctx.drawImage(
          canvas,
          sX,
          sY,
          canvas.width,
          sHeight,
          0,
          0,
          canvas.width,
          sHeight
        );
      
        const pageImg = pageCanvas.toDataURL("image/jpeg"); // add compression ratio for performance
      
        if (position > 0) pdf.addPage();
      
        pdf.addImage(
          pageImg,
          "JPEG",
          MARGIN_LEFT_RIGHT,
          MARGIN_TOP_BOTTOM,
          contentWidth,
          currentPageHeight
        );
      
        position += currentPageHeight;
      }

      pdf.save("company-financial-report.pdf");
    } catch (error) {
      console.error("PDF generation failed:", error);
    } finally {
      setIsGenerating(false); // stop loading
    }
  };

  return { generatePdf, isGenerating };
};
